/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AdminReceiptDetails,
  AdminReceiptList,
  AdminReceiptReviewRequest,
  AdminReceiptsRequest,
  BulkActionResponse,
  QueueListResponse,
  ReceiptDetailsWithImageLinks,
  ReceiptExternalResponse,
  ReceiptExternalUploadRequest,
  ReceiptForwardAliasRequest,
  ReceiptForwardAliasResponse,
  ReceiptsGetV2Params,
  UpdateNormalizedCompanyNameRequest,
  UpdateNormalizedCompanyNameResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `ExternalService`


**Stability Level**: `stable` 

 The image urls returned by this endpoint are intended to be very short lived and to be requested immediately**Sunset Date**: 2025-01-23 - To be removed by developers if they notice this exists after the sunset date
 * @deprecated
 * @summary Gets information about the specified receipt for rebates service.
 */
export const receiptsByReceiptIdAndBuilderExternalIdGetV2 = (
  builderExternalId: string,
  receiptId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ReceiptDetailsWithImageLinks>(
    {
      url: `/apix/v2/Receipts/${builderExternalId}/${receiptId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getReceiptsByReceiptIdAndBuilderExternalIdGetV2QueryKey = (
  builderExternalId?: string,
  receiptId?: number,
) => {
  return [`/apix/v2/Receipts/${builderExternalId}/${receiptId}`] as const;
};

export const getReceiptsByReceiptIdAndBuilderExternalIdGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof receiptsByReceiptIdAndBuilderExternalIdGetV2>
  >,
  TError = ErrorType<void>,
>(
  builderExternalId: string,
  receiptId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof receiptsByReceiptIdAndBuilderExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReceiptsByReceiptIdAndBuilderExternalIdGetV2QueryKey(
      builderExternalId,
      receiptId,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof receiptsByReceiptIdAndBuilderExternalIdGetV2>>
  > = ({ signal }) =>
    receiptsByReceiptIdAndBuilderExternalIdGetV2(
      builderExternalId,
      receiptId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(builderExternalId && receiptId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof receiptsByReceiptIdAndBuilderExternalIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReceiptsByReceiptIdAndBuilderExternalIdGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof receiptsByReceiptIdAndBuilderExternalIdGetV2>>
  >;
export type ReceiptsByReceiptIdAndBuilderExternalIdGetV2QueryError =
  ErrorType<void>;

/**
 * @deprecated
 * @summary Gets information about the specified receipt for rebates service.
 */

export function useReceiptsByReceiptIdAndBuilderExternalIdGetV2<
  TData = Awaited<
    ReturnType<typeof receiptsByReceiptIdAndBuilderExternalIdGetV2>
  >,
  TError = ErrorType<void>,
>(
  builderExternalId: string,
  receiptId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof receiptsByReceiptIdAndBuilderExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getReceiptsByReceiptIdAndBuilderExternalIdGetV2QueryOptions(
      builderExternalId,
      receiptId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `ExternalService`


**Stability Level**: `stable` 

 The image urls returned by this endpoint are intended to be very short lived and to be requested immediately
 * @summary Gets information about the specified receipt.
 */
export const receiptsGetV2 = (
  params?: ReceiptsGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ReceiptExternalResponse>(
    { url: `/apix/v2/Receipts`, method: "GET", params, signal },
    options,
  );
};

export const getReceiptsGetV2QueryKey = (params?: ReceiptsGetV2Params) => {
  return [`/apix/v2/Receipts`, ...(params ? [params] : [])] as const;
};

export const getReceiptsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof receiptsGetV2>>,
  TError = ErrorType<void>,
>(
  params?: ReceiptsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof receiptsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReceiptsGetV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof receiptsGetV2>>> = ({
    signal,
  }) => receiptsGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof receiptsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReceiptsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof receiptsGetV2>>
>;
export type ReceiptsGetV2QueryError = ErrorType<void>;

/**
 * @summary Gets information about the specified receipt.
 */

export function useReceiptsGetV2<
  TData = Awaited<ReturnType<typeof receiptsGetV2>>,
  TError = ErrorType<void>,
>(
  params?: ReceiptsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof receiptsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReceiptsGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `ExternalService`


**Stability Level**: `stable` 

 Receipts are processed asynchronously, so the response will not contain the final status of the receipt.
 * @summary Creates a new receipt for the BT Wallet service.
 */
export const receiptsPostV2 = (
  receiptExternalUploadRequest: BodyType<ReceiptExternalUploadRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Receipts`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: receiptExternalUploadRequest,
      signal,
    },
    options,
  );
};

export const getReceiptsPostV2MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsPostV2>>,
    TError,
    { data: BodyType<ReceiptExternalUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptsPostV2>>,
  TError,
  { data: BodyType<ReceiptExternalUploadRequest> },
  TContext
> => {
  const mutationKey = ["receiptsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptsPostV2>>,
    { data: BodyType<ReceiptExternalUploadRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return receiptsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof receiptsPostV2>>
>;
export type ReceiptsPostV2MutationBody = BodyType<ReceiptExternalUploadRequest>;
export type ReceiptsPostV2MutationError = ErrorType<void>;

/**
 * @summary Creates a new receipt for the BT Wallet service.
 */
export const useReceiptsPostV2 = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsPostV2>>,
    TError,
    { data: BodyType<ReceiptExternalUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof receiptsPostV2>>,
  TError,
  { data: BodyType<ReceiptExternalUploadRequest> },
  TContext
> => {
  const mutationOptions = getReceiptsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets information about the forward address to send receipt for email service.
 */
export const receiptsForwardAddressGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ReceiptForwardAliasResponse>(
    { url: `/apix/v2/Receipts/forward-address`, method: "GET", signal },
    options,
  );
};

export const getReceiptsForwardAddressGetV2QueryKey = () => {
  return [`/apix/v2/Receipts/forward-address`] as const;
};

export const getReceiptsForwardAddressGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof receiptsForwardAddressGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof receiptsForwardAddressGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReceiptsForwardAddressGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof receiptsForwardAddressGetV2>>
  > = ({ signal }) => receiptsForwardAddressGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof receiptsForwardAddressGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReceiptsForwardAddressGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof receiptsForwardAddressGetV2>>
>;
export type ReceiptsForwardAddressGetV2QueryError = ErrorType<void>;

/**
 * @summary Gets information about the forward address to send receipt for email service.
 */

export function useReceiptsForwardAddressGetV2<
  TData = Awaited<ReturnType<typeof receiptsForwardAddressGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof receiptsForwardAddressGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReceiptsForwardAddressGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Set information about the forward address to send receipt for email service.
 */
export const receiptsForwardAddressPostV2 = (
  receiptForwardAliasRequest: BodyType<ReceiptForwardAliasRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void | void>(
    {
      url: `/apix/v2/Receipts/forward-address`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: receiptForwardAliasRequest,
      signal,
    },
    options,
  );
};

export const getReceiptsForwardAddressPostV2MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsForwardAddressPostV2>>,
    TError,
    { data: BodyType<ReceiptForwardAliasRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptsForwardAddressPostV2>>,
  TError,
  { data: BodyType<ReceiptForwardAliasRequest> },
  TContext
> => {
  const mutationKey = ["receiptsForwardAddressPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptsForwardAddressPostV2>>,
    { data: BodyType<ReceiptForwardAliasRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return receiptsForwardAddressPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptsForwardAddressPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof receiptsForwardAddressPostV2>>
>;
export type ReceiptsForwardAddressPostV2MutationBody =
  BodyType<ReceiptForwardAliasRequest>;
export type ReceiptsForwardAddressPostV2MutationError = ErrorType<void>;

/**
 * @summary Set information about the forward address to send receipt for email service.
 */
export const useReceiptsForwardAddressPostV2 = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsForwardAddressPostV2>>,
    TError,
    { data: BodyType<ReceiptForwardAliasRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof receiptsForwardAddressPostV2>>,
  TError,
  { data: BodyType<ReceiptForwardAliasRequest> },
  TContext
> => {
  const mutationOptions =
    getReceiptsForwardAddressPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Update the company name for the receipts email forwarding service.
This can only be done once per account.
 */
export const receiptsNormalizedCompanyNamePutV2 = (
  updateNormalizedCompanyNameRequest: BodyType<UpdateNormalizedCompanyNameRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<UpdateNormalizedCompanyNameResponse>(
    {
      url: `/apix/v2/Receipts/normalized-company-name`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: updateNormalizedCompanyNameRequest,
    },
    options,
  );
};

export const getReceiptsNormalizedCompanyNamePutV2MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsNormalizedCompanyNamePutV2>>,
    TError,
    { data: BodyType<UpdateNormalizedCompanyNameRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptsNormalizedCompanyNamePutV2>>,
  TError,
  { data: BodyType<UpdateNormalizedCompanyNameRequest> },
  TContext
> => {
  const mutationKey = ["receiptsNormalizedCompanyNamePutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptsNormalizedCompanyNamePutV2>>,
    { data: BodyType<UpdateNormalizedCompanyNameRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return receiptsNormalizedCompanyNamePutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptsNormalizedCompanyNamePutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof receiptsNormalizedCompanyNamePutV2>>
>;
export type ReceiptsNormalizedCompanyNamePutV2MutationBody =
  BodyType<UpdateNormalizedCompanyNameRequest>;
export type ReceiptsNormalizedCompanyNamePutV2MutationError = ErrorType<void>;

/**
 * @summary Update the company name for the receipts email forwarding service.
This can only be done once per account.
 */
export const useReceiptsNormalizedCompanyNamePutV2 = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsNormalizedCompanyNamePutV2>>,
    TError,
    { data: BodyType<UpdateNormalizedCompanyNameRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof receiptsNormalizedCompanyNamePutV2>>,
  TError,
  { data: BodyType<UpdateNormalizedCompanyNameRequest> },
  TContext
> => {
  const mutationOptions =
    getReceiptsNormalizedCompanyNamePutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const receiptsBulkCompletePutV2 = (
  receiptsBulkCompletePutV2Body: BodyType<number[]>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<BulkActionResponse>(
    {
      url: `/apix/v2/Receipts/bulk-complete`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: receiptsBulkCompletePutV2Body,
    },
    options,
  );
};

export const getReceiptsBulkCompletePutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsBulkCompletePutV2>>,
    TError,
    { data: BodyType<number[]> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptsBulkCompletePutV2>>,
  TError,
  { data: BodyType<number[]> },
  TContext
> => {
  const mutationKey = ["receiptsBulkCompletePutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptsBulkCompletePutV2>>,
    { data: BodyType<number[]> }
  > = (props) => {
    const { data } = props ?? {};

    return receiptsBulkCompletePutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptsBulkCompletePutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof receiptsBulkCompletePutV2>>
>;
export type ReceiptsBulkCompletePutV2MutationBody = BodyType<number[]>;
export type ReceiptsBulkCompletePutV2MutationError = ErrorType<unknown>;

export const useReceiptsBulkCompletePutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsBulkCompletePutV2>>,
    TError,
    { data: BodyType<number[]> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof receiptsBulkCompletePutV2>>,
  TError,
  { data: BodyType<number[]> },
  TContext
> => {
  const mutationOptions = getReceiptsBulkCompletePutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 * @summary Gets a list of receipts for builder accounts with the rebates flag enabled
 */
export const adminReceiptsPostV2 = (
  adminReceiptsRequest: BodyType<AdminReceiptsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AdminReceiptList>(
    {
      url: `/apix/v2/admin/Receipts`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: adminReceiptsRequest,
      signal,
    },
    options,
  );
};

export const getAdminReceiptsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReceiptsPostV2>>,
    TError,
    { data: BodyType<AdminReceiptsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminReceiptsPostV2>>,
  TError,
  { data: BodyType<AdminReceiptsRequest> },
  TContext
> => {
  const mutationKey = ["adminReceiptsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminReceiptsPostV2>>,
    { data: BodyType<AdminReceiptsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminReceiptsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminReceiptsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminReceiptsPostV2>>
>;
export type AdminReceiptsPostV2MutationBody = BodyType<AdminReceiptsRequest>;
export type AdminReceiptsPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Gets a list of receipts for builder accounts with the rebates flag enabled
 */
export const useAdminReceiptsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReceiptsPostV2>>,
    TError,
    { data: BodyType<AdminReceiptsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminReceiptsPostV2>>,
  TError,
  { data: BodyType<AdminReceiptsRequest> },
  TContext
> => {
  const mutationOptions = getAdminReceiptsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 * @summary Get receipt details based on the receipt id
 */
export const adminReceiptsByIdGetV2 = (
  id: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AdminReceiptDetails>(
    { url: `/apix/v2/admin/Receipts/${id}`, method: "GET", signal },
    options,
  );
};

export const getAdminReceiptsByIdGetV2QueryKey = (id?: number) => {
  return [`/apix/v2/admin/Receipts/${id}`] as const;
};

export const getAdminReceiptsByIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminReceiptsByIdGetV2>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminReceiptsByIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminReceiptsByIdGetV2QueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminReceiptsByIdGetV2>>
  > = ({ signal }) => adminReceiptsByIdGetV2(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminReceiptsByIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminReceiptsByIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminReceiptsByIdGetV2>>
>;
export type AdminReceiptsByIdGetV2QueryError = ErrorType<void>;

/**
 * @summary Get receipt details based on the receipt id
 */

export function useAdminReceiptsByIdGetV2<
  TData = Awaited<ReturnType<typeof adminReceiptsByIdGetV2>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminReceiptsByIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminReceiptsByIdGetV2QueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminReceiptsQueuesGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<QueueListResponse>(
    { url: `/apix/v2/admin/Receipts/queues`, method: "GET", signal },
    options,
  );
};

export const getAdminReceiptsQueuesGetV2QueryKey = () => {
  return [`/apix/v2/admin/Receipts/queues`] as const;
};

export const getAdminReceiptsQueuesGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminReceiptsQueuesGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminReceiptsQueuesGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminReceiptsQueuesGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminReceiptsQueuesGetV2>>
  > = ({ signal }) => adminReceiptsQueuesGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminReceiptsQueuesGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminReceiptsQueuesGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminReceiptsQueuesGetV2>>
>;
export type AdminReceiptsQueuesGetV2QueryError = ErrorType<unknown>;

export function useAdminReceiptsQueuesGetV2<
  TData = Awaited<ReturnType<typeof adminReceiptsQueuesGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminReceiptsQueuesGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminReceiptsQueuesGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 * @summary Adds review information for the receipts line items
 */
export const adminReceiptsReviewByIdPostV2 = (
  id: number,
  adminReceiptReviewRequest: BodyType<AdminReceiptReviewRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AdminReceiptDetails>(
    {
      url: `/apix/v2/admin/Receipts/${id}/review`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: adminReceiptReviewRequest,
      signal,
    },
    options,
  );
};

export const getAdminReceiptsReviewByIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReceiptsReviewByIdPostV2>>,
    TError,
    { id: number; data: BodyType<AdminReceiptReviewRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminReceiptsReviewByIdPostV2>>,
  TError,
  { id: number; data: BodyType<AdminReceiptReviewRequest> },
  TContext
> => {
  const mutationKey = ["adminReceiptsReviewByIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminReceiptsReviewByIdPostV2>>,
    { id: number; data: BodyType<AdminReceiptReviewRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminReceiptsReviewByIdPostV2(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminReceiptsReviewByIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminReceiptsReviewByIdPostV2>>
>;
export type AdminReceiptsReviewByIdPostV2MutationBody =
  BodyType<AdminReceiptReviewRequest>;
export type AdminReceiptsReviewByIdPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Adds review information for the receipts line items
 */
export const useAdminReceiptsReviewByIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReceiptsReviewByIdPostV2>>,
    TError,
    { id: number; data: BodyType<AdminReceiptReviewRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminReceiptsReviewByIdPostV2>>,
  TError,
  { id: number; data: BodyType<AdminReceiptReviewRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminReceiptsReviewByIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
